__turbopack_context__.v({
  "compact": "MediaContainer-module__YC4-6W__compact",
  "container": "MediaContainer-module__YC4-6W__container",
});
